import { IsNotEmpty, IsString } from 'class-validator';

export class ContratoTopicDto {
  @IsString()
  @IsNotEmpty()
  contratoId: string;
}
